<div [formGroup]="form" [ngClass]="{ blur: !('basic-profile.fields.technician-data' | translate) }">
  <app-review-section
    [title]="'basic-profile.fields.technician-data-concession' | translate"
    [showAcceptRejectButtons]="false"
    [showMessages]="false"></app-review-section>

  <div class="ui-g-12 margin-align" *ngIf="form.controls.technician_id">
    <label class="ui-g-5" for="data-input-technician ID">
      {{ 'basic-profile.fields.technician_id' | translate }}
    </label>
    <input
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="technician_id"
      id="data-input-technician ID"
      pInputText
      size="30"
      readonly
      type="text"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-anrede" class="ui-g-5 required">{{ 'basic-profile.fields.title' | translate }}</label>

    <p-dropdown
      [options]="allTitles"
      formControlName="sk_title"
      id="float-input-anrede"
      (onChange)="updateTechnician({ isFromAutosave: true })"
      placeholder="-Select-"
      [disabled]="readonly">
      <ng-template let-item pTemplate="selectedItem">
        <span class="drop-item-label">
          {{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}
        </span>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="drop-item">
          <span class="drop-item-label">
            {{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}
          </span>
        </div>
      </ng-template>
    </p-dropdown>
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-varname" class="ui-g-5 required">
      {{ 'basic-profile.fields.first_name' | translate }}
    </label>
    <input
      id="float-input-varname"
      type="text"
      size="30"
      pInputText
      maxlength="50"
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="first_name"
      (change)="updateTechnician({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-name" class="ui-g-5 required">{{ 'basic-profile.fields.name' | translate }}</label>
    <input
      id="float-input-name"
      type="text"
      size="30"
      pInputText
      maxlength="50"
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="last_name"
      (change)="updateTechnician({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-geburtsdatum" class="ui-g-5 required">
      {{ 'basic-profile.fields.birthday' | translate }}
    </label>
    <p-calendar
      tabIndex="0"
      appCalendarEscapeClose
      *ngIf="'app.calendar-settings' | translate"
      id="float-input-geburtsdatum"
      formControlName="birthday"
      [dateFormat]="dateFormat.dateFormat"
      [placeholder]="dateFormat.placeholder"
      [locale]="'app.calendar-settings' | translate"
      [monthNavigator]="true"
      [yearNavigator]="true"
      yearRange="1900:2080"
      (onClose)="updateTechnician({ isFromAutosave: true })"
      [disabled]="readonly"></p-calendar>
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-telefon" class="ui-g-5 required">
      {{ 'basic-profile.fields.telephone_mobile_number' | translate }}
    </label>
    <input
      id="float-input-telefon"
      [appNumber]="true"
      size="30"
      pInputText
      maxlength="50"
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="telephone"
      (change)="updateTechnician({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align" *ngIf="showMastersExaminationOn">
    <label for="float-input-geburtsdatum" class="ui-g-5 required">
      {{ 'basic-profile.fields.masters_examination_on' | translate }}
    </label>
    <p-calendar
      tabIndex="0"
      appCalendarEscapeClose
      id="float-input-geburtsdatum"
      formControlName="qualification_issued_on"
      [dateFormat]="dateFormat.dateFormat"
      [placeholder]="dateFormat.placeholder"
      [locale]="'app.calendar-settings' | translate"
      [monthNavigator]="true"
      [yearNavigator]="true"
      yearRange="1900:2080"
      (onClose)="updateTechnician({ isFromAutosave: true })"
      [disabled]="readonly"></p-calendar>
  </div>

  <div class="ui-g-12 margin-align" *ngIf="showTechnicianDataEmail">
    <label for="float-input-technician-email" class="ui-g-5 required">
      {{ 'basic-profile.fields.mail' | translate }}
    </label>
    <input
      id="float-input-technician-email"
      type="text"
      size="30"
      pInputText
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="email"
      (change)="updateTechnician({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>
  <div class="ui-g-12 margin-align" *ngIf="showGuildMember">
    <label for="input-technician-guild-member" class="ui-g-5"></label>
    <p-checkbox
      (onChange)="updateTechnician({ isFromAutosave: true })"
      binary="true"
      formControlName="is_guild_member"
      name="is_guild_member"
      label="{{ 'basic-profile.fields.guild-member' | translate }}"
      [disabled]="readonly || null"></p-checkbox>
  </div>
</div>
